export default {
    getTransactionFilter: (state) => state.filter,
    getTransactionList: (state) => state.list,
    getTransactionResult: (state) => state.result,
    getTransactionValidation: (state) => state.validation,
  };